import {Component, EventEmitter, OnInit, Output, ChangeDetectionStrategy} from '@angular/core';

@Component({
    selector: 'bic-card',
    templateUrl: './bic-card.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrls: ['./bic-card.component.scss']
})
export class BicCardComponent implements OnInit {

  @Output() click = new EventEmitter<void>();

  constructor() { }

  ngOnInit(): void {
  }

}
